/* global Gridzy */
import "./lib/gridzy.js"; // quiet

let gridzys = [];

let resizeHandlerAdded = false;

export default {
    init: () => {
        document.querySelectorAll(".gridzy").forEach((el) => {
            const options = JSON.parse(el.dataset.gridzyConfig);

            function generateOptions() {
                if (window.innerWidth < 960) {
                    return options.mobile;
                }
                return options.desktop;
            }

            gridzys = [
                {
                    gridzyInstance: new Gridzy(el, generateOptions()),
                    generateOptions
                }
            ];
        });

        if (!resizeHandlerAdded) {
            window.addEventListener("resize", function () {
                gridzys.forEach(({ gridzyInstance, generateOptions }) => {
                    gridzyInstance.setOptions(generateOptions());
                });
            });
        }

        resizeHandlerAdded = true;
    },
    cleanup: () => {
        gridzys.forEach(({ gridzyInstance }) => gridzyInstance.destroy());

        gridzys = [];
    }
};
